<template>
  <div>
    <!-- PERSONAL INFORMATION -->
    <template>
      <div
        class="d-flex justify-content-end mb-1 mt-2"
        id="fixed-buttons"
        :class="{ fixed: isFixed }"
      >
        <b-button
          v-if="edit === true"
          :variant="isFixed ? 'warning' : 'outline-warning'"
          class="mr-1"
          @click="editEmployeeBasicInformation"
        >
          <feather-icon icon="Edit2Icon" class="mr-50" />
          {{ $t("EDIT") }}
        </b-button>
        <b-button
          v-if="edit === false"
          :variant="isFixed ? 'success' : 'outline-success'"
          class="mr-1"
          @click="updateEmployee"
        >
          <feather-icon icon="SaveIcon" class="mr-50" />
          {{ $t("SAVE") }}
        </b-button>
        <b-button
          v-if="edit === false"
          :variant="isFixed ? 'danger' : 'outline-danger'"
          class="mr-1"
          @click="refresh"
        >
          {{ $t("CANCEL") }}
        </b-button>
      </div>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu">
            {{ $t("PERSONAL INFORMATION") }}
          </b-card-title>
        </template>

        <template #default>
          <validation-observer ref="form1">
            <b-row>
              <!-- First Name -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                <validation-provider
                  v-slot="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <b-form-group>
                    <template #label>
                      {{ $t("First Name") }}
                      <span class="text-danger">(*)</span>
                    </template>
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="first-name"
                      v-model="userData.first_name"
                      name="first-name"
                      :state="errors[0] ? false : null"
                      :disabled="edit"
                      trim
                      autofocus
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- LastName -->
              <b-col lg="4" xl="4" md="6" sm="6" xs="12" class="mt-1">
                <validation-provider
                  v-slot="{ errors }"
                  name="LastName"
                  rules="required"
                >
                  <b-form-group>
                    <template #label>
                      {{ $t("Last Name") }}
                      <span class="text-danger">(*)</span>
                    </template>

                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="last-name"
                      v-model="userData.last_name"
                      :state="errors[0] ? false : null"
                      :disabled="edit"
                      trim
                      autofocus
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- DocType -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider
                  v-slot="{ errors }"
                  name="DocType"
                  rules="required"
                >
                  <b-form-group :state="errors[0] ? false : null">
                    <template #label>
                      {{ $t("Document Type") }}
                      <span class="text-danger">(*)</span>
                    </template>

                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <v-select
                      v-if="finishedLoading"
                      id="doc-type"
                      v-model="userData.document_type_id"
                      :placeholder="$t('Select a Document Type')"
                      :class="errors[0] ? 'border-danger' : ''"
                      :disabled="edit"
                      :reduce="(value) => value.id"
                      label="name"
                      :options="document"
                      autofocus
                      :clearable="!edit"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- NumberDoc -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider
                  v-slot="{ errors }"
                  name="NumberDoc"
                  rules="required"
                >
                  <b-form-group>
                    <template #label>
                      {{ $t("Document Number") }}
                      <span class="text-danger">(*)</span>
                    </template>

                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="number-doc"
                      v-model="userData.document_number"
                      trim
                      :state="errors[0] ? false : null"
                      :disabled="edit"
                      autofocus
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- DOB -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider name="DOB">
                  <b-form-group :label="$t('DOB')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      class="form-control-kendo"
                      :format="'MM/dd/yyyy'"
                      v-model="userData.dob"
                      :disabled="edit"
                      autofocus
                      v-mask="'##/##/####'"
                      :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Gender-->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider name="Gender">
                  <b-form-group :label="$t('Gender')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <v-select
                      :clearable="!edit"
                      v-model="userData.gender"
                      :disabled="edit"
                      v-if="finishedLoading"
                      label="name"
                      autofocus
                      :reduce="(value) => value.id"
                      :options="optionsgender"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Martial-->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider name="Martial">
                  <b-form-group :label="$t('Martial')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <v-select
                      :clearable="!edit"
                      v-model="userData.martial_id"
                      :disabled="edit"
                      v-if="finishedLoading"
                      autofocus
                      label="name"
                      :options="martial"
                      :reduce="(value) => value.id"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Blood type -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider v-slot="{ errors }">
                  <b-form-group :label="$t('Blood Type')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="blood_type"
                      autofocus
                      v-model="userData.blood_type"
                      trim
                      :state="errors[0] ? false : null"
                      :disabled="edit"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </template>
      </b-card>
    </template>

    <!-- CONTACT INFORMATION -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu">
            {{ $t("CONTACT INFORMATION") }}
          </b-card-title>
        </template>
        <template #default>
          <b-row>
            <!-- Country-->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="Country">
                <b-form-group :label="$t('Country')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <v-select
                    :clearable="!edit"
                    v-model="userData.country_id"
                    :disabled="edit"
                    v-if="finishedLoading"
                    label="name"
                    :options="countries"
                    :reduce="(value) => value.id"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- Department -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="department">
                <b-form-group :label="$t('Department')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="department"
                    v-model="userData.department"
                    name="department"
                    :disabled="edit"
                    autofocus
                    trim
                    type="text"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Province -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="province">
                <b-form-group :label="$t('Province')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="province"
                    v-model="userData.province"
                    name="province"
                    :disabled="edit"
                    type="text"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- District -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="district">
                <b-form-group :label="$t('District')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="department"
                    v-model="userData.district"
                    name="district"
                    :disabled="edit"
                    autofocus
                    trim
                    type="text"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- zip code -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="zip-code">
                <b-form-group :label="$t('Zip Code')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="zip-code"
                    v-model="userData.zip_code"
                    name="zip_code"
                    :disabled="edit"
                    type="text"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Mailing  Address -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="MailingAddress">
                <b-form-group :label="$t('Address')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="mailing-address"
                    v-model="userData.address"
                    name="mailing-address"
                    autofocus
                    trim
                    :disabled="edit"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- home phone -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="home-phone">
                <b-form-group :label="$t('Home Phone')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="home-phone"
                    v-model="userData.home_phone"
                    name="home_phone"
                    :disabled="edit"
                    type="text"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Mobile Phone -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="Mobile Phone">
                <b-form-group :label="$t('Mobile Phone')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="mobile-phone"
                    v-model="userData.cell_phone"
                    v-mask="'###-###-###'"
                    :disabled="edit"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Work Phone -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="Work Phone">
                <b-form-group :label="$t('Work Phone')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="work-phone"
                    v-model="userData.work_phone"
                    v-mask="'(XXX)-XXX-XXXX'"
                    trim
                    autofocus
                    :disabled="edit"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Work Email -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider
                v-slot="{ errors }"
                name="WorkEmail"
                rules="email"
              >
                <b-form-group :label="$t('Work Email')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="work-email"
                    v-model="userData.work_email"
                    type="email"
                    :disabled="edit"
                    trim
                    autofocus
                    :state="errors[0] ? false : null"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Private Email -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider
                v-slot="{ errors }"
                name="private-email"
                rules="email"
              >
                <b-form-group :label="$t('Private Email')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="private-email"
                    v-model="userData.private_email"
                    type="email"
                    :disabled="edit"
                    :state="errors[0] ? false : null"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </template>

    <!-- BORN INFORMATION -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu">
            {{ $t("Born Information") }}
          </b-card-title>
        </template>

        <template #default>
          <b-row>
            <!-- Born Address -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="Born Address">
                <b-form-group :label="$t('Born Address')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="born-address"
                    v-model="userData.born_address"
                    name="born-address"
                    autofocus
                    trim
                    :disabled="edit"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Country-->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="Born Country">
                <b-form-group :label="$t('Born Country')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <v-select
                    :clearable="!edit"
                    v-model="userData.born_country_id"
                    :disabled="edit"
                    v-if="finishedLoading"
                    label="name"
                    :options="countries"
                    :reduce="(value) => value.id"
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Department -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="born_department">
                <b-form-group :label="$t('Born Department')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="born_department"
                    v-model="userData.born_department"
                    name="born_department"
                    autofocus
                    trim
                    :disabled="edit"
                    type="text"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Province -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="born_province">
                <b-form-group :label="$t('Born Province')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="born_province"
                    v-model="userData.born_province"
                    name="born_province"
                    autofocus
                    trim
                    :disabled="edit"
                    type="text"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- District -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="born_district">
                <b-form-group :label="$t('Born District')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="born_district"
                    v-model="userData.born_district"
                    name="born_district"
                    :disabled="edit"
                    type="text"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- zip code -->
            <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
              <validation-provider name="born-zip-code">
                <b-form-group :label="$t('Born Zip Code')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="born-zip-code"
                    v-model="userData.born_zip_code"
                    name="born_zip_code"
                    :disabled="edit"
                    type="text"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </template>

    <!-- CHILDREN -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu w-100">
            <div class="d-flex justify-content-between">
              <span>{{ $t("CHILDREN") }}</span>
              <b-button
                v-if="!edit"
                size="sm"
                variant="outline-success"
                v-b-tooltip.hover.right="$t('Add Children')"
                @click="addChildren"
              >
                <feather-icon icon="PlusIcon" class="text-success" />
              </b-button>
            </div>
          </b-card-title>
        </template>
        <template #default>
          <b-row v-for="(data2, index) in userData.children" :key="index">
            <b-col>
              <b-row class="mt-1">
                <b-col :md="!edit ? '3' : '4'">
                  <!-- Son Names -->
                  <validation-provider name="son_names">
                    <b-form-group>
                      <template #label>
                        {{ $t("Names") }}
                        <span class="text-danger">(*)</span>
                      </template>

                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="son_names1"
                        v-model="data2.names"
                        name="son_names1"
                        :disabled="edit"
                        type="text"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Son  Gender -->
                <b-col lg="2" md="6">
                  <validation-provider name="son_geder">
                    <b-form-group>
                      <template #label>
                        {{ $t("Gender") }}
                        <span class="text-danger">(*)</span>
                      </template>

                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <v-select
                        :clearable="!edit"
                        v-model="data2.gender"
                        :disabled="edit"
                        v-if="finishedLoading"
                        label="name"
                        :reduce="(value) => value.id"
                        :options="optionsgender"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Son Document Number -->
                <b-col lg="2" md="6">
                  <validation-provider name="son_document_number">
                    <b-form-group>
                      <template #label>
                        {{ $t("DNI") }}
                        <!-- <span class="text-danger">(*)</span> -->
                      </template>

                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="ocupation"
                        v-model="data2.document_number"
                        type="text"
                        :disabled="edit"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- Son Age -->
                <b-col lg="2" md="6">
                  <validation-provider name="son_age">
                    <b-form-group>
                      <template #label>
                        {{ $t("Age") }}
                        <span class="text-danger">(*)</span>
                      </template>

                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <b-form-input
                        v-if="finishedLoading"
                        id="ocupation"
                        v-model="data2.age"
                        type="number"
                        :disabled="edit"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <!-- DOB -->
                <b-col lg="2" md="6">
                  <validation-provider name="son_dob">
                    <b-form-group>
                      <template #label>
                        {{ $t("DOB") }}
                        <span class="text-danger">(*)</span>
                      </template>
                      <b-skeleton v-if="!finishedLoading" type="input" />
                      <kendo-datepicker
                        v-if="finishedLoading"
                        class="form-control-kendo"
                        :format="'MM/dd/yyyy'"
                        v-model="data2.dob"
                        :disabled="edit"
                        v-mask="'##/##/####'"
                        :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                      />
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="1" sm="12" class="d-flex align-items-center">
                  <b-button
                    v-if="!edit"
                    size="sm"
                    variant="outline-danger"
                    class="w-100 mt-1"
                    v-b-tooltip.hover.right="$t('Delete Son')"
                    @click="deleteSon(index)"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      class="text-danger"
                      size="19"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </b-card>

      <div></div>
    </template>

    <!-- EMERGENCY CONTACT -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu">
            {{ $t("EMERGENCY CONTACT") }}
          </b-card-title>
        </template>
        <template #default>
          <b-row v-for="(data, index) in userData.contacts" :key="index">
            <b-col lg="3" xl="3" md="6" sm="6" class="mt-1">
              <!-- Contact  Name -->
              <validation-provider name="Contact Name">
                <b-form-group :label="$t('Name')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="contact-name1"
                    v-model="data.name"
                    name="contact-name1"
                    :disabled="edit"
                    type="text"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Contact Phone -->
            <b-col lg="3" xl="3" md="6" sm="6" class="mt-1">
              <validation-provider name="Contact Phone">
                <b-form-group :label="$t('Phone')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="contact-phone1"
                    v-model="data.phone"
                    type="number"
                    :disabled="edit"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Contact Ocupation -->
            <b-col lg="3" xl="3" md="6" sm="6" class="mt-1">
              <validation-provider name="Contact Occupation">
                <b-form-group :label="$t('Occupation')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <b-form-input
                    v-if="finishedLoading"
                    id="ocupation"
                    v-model="data.occupation"
                    type="text"
                    :disabled="edit"
                    trim
                    autofocus
                  />
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Contact Relation -->
            <b-col lg="3" xl="3" md="6" sm="6" class="mt-1">
              <validation-provider name="Relation">
                <b-form-group :label="$t('Relation')">
                  <b-skeleton
                    v-if="!finishedLoading"
                    class="w-100"
                    type="input"
                  />
                  <v-select
                    :disabled="edit"
                    v-if="finishedLoading"
                    v-model="data.relation_id"
                    label="name"
                    :reduce="(value) => value.id"
                    :options="relations"
                    autofocus
                    :clearable="!edit"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </template>
      </b-card>

      <div></div>
    </template>

    <!-- APPLIED STUDIES -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu w-100">
            <div class="d-flex justify-content-between">
              <span>{{ $t("APPLIED STUDIES") }}</span>
              <b-button
                v-if="!edit"
                size="sm"
                variant="outline-success"
                v-b-tooltip.hover.right="$t('Add Studies')"
                @click="addStudies"
              >
                <feather-icon icon="PlusIcon" class="text-success" />
              </b-button>
            </div>
          </b-card-title>
        </template>
        <template #default>
          <b-row v-for="(data, index) in userData.studies" :key="index">
            <b-col>
              <b-row class="mt-1">
                <!-- Study Center -->
                <b-col md="3">
                  <b-form-group>
                    <template #label>
                      {{ $t("Study Center") }}
                      <span class="text-danger">(*)</span>
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.study_center"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Carrera -->
                <b-col :md="edit ? '3' : '2'">
                  <b-form-group>
                    <template #label>
                      {{ $t("Carrera") }}
                      <!-- <span class="text-danger">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.carrera"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Study Grade -->
                <b-col md="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Study Grade") }}
                      <span class="text-danger">(*)</span>
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.study_grade"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Start Date -->
                <b-col md="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Start Date") }}
                      <!-- <span class="text-danger">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      class="form-control-kendo"
                      :format="'MM/dd/yyyy'"
                      v-model="data.start_date"
                      :disabled="edit"
                      v-mask="'##/##/####'"
                      :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    />
                  </b-form-group>
                </b-col>

                <!-- Finish Date -->
                <b-col md="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Finish Date") }}
                      <!-- <span class="text-danger text-truncate">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      class="form-control-kendo"
                      :format="'MM/dd/yyyy'"
                      v-model="data.finish_date"
                      :disabled="edit"
                      v-mask="'##/##/####'"
                      :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    />
                  </b-form-group>
                </b-col>

                <!-- Delete -->
                <b-col
                  v-if="!edit"
                  md="1"
                  sm="12"
                  class="d-flex align-items-center"
                >
                  <b-button
                    size="sm"
                    variant="outline-danger"
                    class="w-100 mt-1"
                    v-b-tooltip.hover.right="$t('Delete Study')"
                    @click="deleteStudy(index)"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      class="text-danger"
                      size="19"
                    />
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </b-card>

      <div></div>
    </template>

    <!-- WORK EXPERIENCE -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu w-100">
            <div class="d-flex justify-content-between">
              <span>{{ $t("WORK EXPERIENCE") }}</span>
              <b-button
                v-if="!edit"
                size="sm"
                variant="outline-success"
                v-b-tooltip.hover.right="$t('Add Experience')"
                @click="addExperience"
              >
                <feather-icon icon="PlusIcon" class="text-success" />
              </b-button>
            </div>
          </b-card-title>
        </template>
        <template #default>
          <b-row v-for="(data, index) in userData.experience" :key="index">
            <b-col :md="edit ? '12' : '11'">
              <b-row class="mt-1">
                <!-- Compnay Position -->
                <b-col md="4" lg="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Company Position") }}
                      <span class="text-danger text-truncate">(*)</span>
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.company_position"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Company -->
                <b-col md="4" lg="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Company") }}
                      <span class="text-danger text-truncate">(*)</span>
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.company"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Reference Contact -->
                <b-col md="4" lg="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Reference Contact") }}
                      <!-- <span class="text-danger text-truncate">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.reference_contact"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Number Contact -->
                <b-col md="4" lg="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Number Contact") }}
                      <!-- <span class="text-danger text-truncate">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.number_contact"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- Start Date -->
                <b-col md="4" lg="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Start Date") }}
                      <!-- <span class="text-danger text-truncate">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      class="form-control-kendo"
                      :format="'MM/dd/yyyy'"
                      v-model="data.start_date"
                      :disabled="edit"
                      v-mask="'##/##/####'"
                      :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    />
                  </b-form-group>
                </b-col>

                <!-- Finish Date -->
                <b-col md="4" lg="2">
                  <b-form-group>
                    <template #label>
                      {{ $t("Finish Date") }}
                      <!-- <span class="text-danger text-truncate">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <kendo-datepicker
                      v-if="finishedLoading"
                      class="form-control-kendo"
                      :format="'MM/dd/yyyy'"
                      v-model="data.finish_date"
                      :disabled="edit"
                      v-mask="'##/##/####'"
                      :class="[isDarkSkin ? ' bg-transparent' : '', '']"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col
              v-if="!edit"
              md="1"
              sm="12"
              class="d-flex align-items-center"
            >
              <b-button
                size="sm"
                variant="outline-danger"
                class="w-100 mt-1"
                v-b-tooltip.hover.right="$t('Delete Experience')"
                @click="deleteExperience(index)"
              >
                <feather-icon icon="Trash2Icon" class="text-danger" size="19" />
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-card>

      <div></div>
    </template>

    <!-- EMPLOYEE SIZES -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu">
            {{ $t("PERSONAL CLOTHING SIZE") }}
          </b-card-title>
        </template>
        <template #default>
          <validation-observer ref="form2">
            <b-row>
              <!-- Pant -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider v-slot="{ errors }" name="Pants">
                  <b-form-group :label="$t('Pant')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="pants"
                      v-model="userData.pants_size"
                      name="pants"
                      autofocus
                      :state="errors[0] ? false : null"
                      trim
                      :disabled="edit"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Shirt -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider v-slot="{ errors }" name="Shirt">
                  <b-form-group :label="$t('Shirt')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="shirt"
                      v-model="userData.shirt_size"
                      name="shirt"
                      autofocus
                      :state="errors[0] ? false : null"
                      trim
                      :disabled="edit"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- Shoe -->
              <b-col lg="4" xl="4" md="6" sm="6" class="mt-1">
                <validation-provider v-slot="{ errors }" name="Shoe">
                  <b-form-group :label="$t('Shoe')">
                    <b-skeleton
                      v-if="!finishedLoading"
                      class="w-100"
                      type="input"
                    />
                    <b-form-input
                      v-if="finishedLoading"
                      id="shoe"
                      v-model="userData.shoe_size"
                      name="shoe"
                      autofocus
                      :state="errors[0] ? false : null"
                      trim
                      :disabled="edit"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </template>
      </b-card>
    </template>

    <!-- Employee Bank Accounts -->
    <template>
      <b-card>
        <template #header>
          <b-card-title class="title-uwu w-100">
            <div class="d-flex justify-content-between">
              <span>{{ $t("BANK ACCOUNTS") }}</span>
              <b-button
                v-if="!edit"
                size="sm"
                variant="outline-success"
                v-b-tooltip.hover.right="$t('Add Bank Account')"
                @click="addBankAccount"
              >
                <feather-icon icon="PlusIcon" class="text-success" />
              </b-button>
            </div>
          </b-card-title>
        </template>
        <template #default>
          <b-row v-for="(data, index) in userData.bank_accounts" :key="index">
            <b-col :md="edit ? '12' : '11'">
              <b-row class="mt-1">
                <!-- Bank -->
                <b-col lg="3" xl="3" md="6" sm="6">
                  <b-form-group>
                    <template #label>
                      {{ $t("Bank") }}
                      <span class="text-danger text-truncate">(*)</span>
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      :disabled="edit"
                      v-if="finishedLoading"
                      v-model="data.bank_id"
                      label="name"
                      :reduce="(value) => value.id"
                      :options="banks"
                      :clearable="!edit"
                      style="max-width: 100%"
                    >
                      <template #selected-option="{ name }">
                        <span class="text-truncate">{{ name }}</span>
                      </template>
                    </v-select>
                  </b-form-group>
                </b-col>

                <!-- Bank Account Type -->
                <b-col lg="3" xl="3" md="6" sm="6">
                  <b-form-group>
                    <template #label>
                      {{ $t("Bank Account Type") }}
                      <span class="text-danger text-truncate">(*)</span>
                    </template>
                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <v-select
                      :disabled="edit"
                      v-if="finishedLoading"
                      v-model="data.bank_account_type_id"
                      label="name"
                      :clearable="!edit"
                      :reduce="(value) => value.id"
                      :options="bank_account_types"
                    />
                  </b-form-group>
                </b-col>

                <!-- Account Number -->
                <b-col lg="3" xl="3" md="6" sm="6">
                  <b-form-group>
                    <template #label>
                      {{ $t("Account Number") }}
                      <span class="text-danger text-truncate">(*)</span>
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.account_number"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>

                <!-- CCI -->
                <b-col lg="3" xl="3" md="6" sm="6">
                  <b-form-group>
                    <template #label>
                      {{ $t("CCI") }}
                      <!-- <span class="text-danger text-truncate">(*)</span> -->
                    </template>

                    <b-skeleton v-if="!finishedLoading" type="input" />
                    <b-form-input
                      v-if="finishedLoading"
                      placeholder=""
                      v-model="data.cci"
                      :disabled="edit"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col
              v-if="!edit"
              md="1"
              sm="12"
              class="d-flex align-items-center"
            >
              <b-button
                size="sm"
                variant="outline-danger"
                class="w-100 mt-1"
                v-b-tooltip.hover.right="$t('Delete Bank Account')"
                @click="deleteBankAccount(data, index)"
              >
                <feather-icon icon="Trash2Icon" class="text-danger" size="19" />
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-card>

      <div></div>
    </template>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import EmployeesService from "@/views/rrhh/views/employees/services/employee.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters, mapState } from "vuex";
import { createPopper } from "@popperjs/core";
// import WebSocketService from "@/ws/WebSocketService.js";

export default {
  name: "BasicInformation",
  components: {
    vSelect,
    ToastificationContent,
  },
  data() {
    return {
      optionsgender: [
        { id: 1, name: this.$t("Female") },
        { id: 2, name: this.$t("Male") },
      ],
      userData: {
        file: "",
      },
      finishedLoading: false,
      relations: [],
      countries: [],
      department: [],
      martial: [],
      document: [],
      image: null,
      optionsRol: [],
      edit: true,
      userDataRefresh: [],
      banks: [],
      bank_account_types: [],
      isFixed: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  mounted() {
    this.getAllDocuments();
    this.getAllMartial();
    this.getAllRelations();
    this.getCountries();
    this.getBanks();
    this.getBankAccountTypes();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  async created() {
    await this.getInformationEmployeer();
    this.finishedLoading = true;
  },
  methods: {
    handleScroll() {
      var scrollPosition = window.scrollY || document.documentElement.scrollTop;
      this.isFixed = scrollPosition > 450;
    },

    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: "top",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            },
          },
        ],
      });
      return () => popper.destroy();
    },
    async getCountries() {
      try {
        const { data } = await EmployeesService.getCountries();
        this.countries = data;
        return this.countries;
      } catch (error) {
        console.log(error);
      }
    },
    async getBanks() {
      try {
        const { data } = await EmployeesService.getBanks();
        this.banks = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getBankAccountTypes() {
      try {
        const { data } = await EmployeesService.getBankAccountTypes();
        this.bank_account_types = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getAllRelations() {
      try {
        this.addPreloader();
        const { data } = await EmployeesService.getAllRelations();
        this.relations = data;
        return this.relations;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async getAllDocuments() {
      try {
        this.addPreloader();
        const { data } = await EmployeesService.getAllDocumentTypes({});
        this.document = data;
        return this.document;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async getAllMartial() {
      try {
        this.addPreloader();
        const { data } = await EmployeesService.getAllMartial();
        this.martial = data;
        return this.martial;
      } catch (e) {
        console.log(e);
        // this.showErrorSwal(e);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    async editEmployeeBasicInformation() {
      this.edit = !this.edit;
    },
    // hacer update en la tabla hr_salaries para determinar su cuenta bancaria principal estara relacoonada con employee bank accout
    async updateEmployee() {
      try {
        const result1 = await this.$refs.form1.validate();
        const result2 = await this.$refs.form2.validate();

        if (result1 && result2) {
          const response = await this.showConfirmSwal();
          if (response.isConfirmed) {
            this.addPreloader();
            const params = {
              //Personal Information
              id: this.$route.params.id,
              first_name: this.userData.first_name,
              last_name: this.userData.last_name,
              document_type: this.userData.document_type_id,
              document_number: this.userData.document_number,
              dob: moment(this.userData.dob).format("YYYY-MM-DD"),
              gender: this.userData.gender,
              martial: this.userData.martial_id,
              blood_type: this.userData.blood_type,

              //Contact Information
              address: this.userData.address,
              country: this.userData.country_id,
              department: this.userData.department,
              province: this.userData.province,
              district: this.userData.district,
              zip_code: this.userData.zip_code,
              home_phone: this.userData.home_phone,
              mobile_phone: this.userData.cell_phone,
              work_phone: this.userData.work_phone,
              work_email: this.userData.work_email,
              private_email: this.userData.private_email,

              // Born Information
              born_address: this.userData.born_address,
              born_country: this.userData.born_country_id,
              born_department: this.userData.born_department,
              born_province: this.userData.born_province,
              born_district: this.userData.born_district,
              born_zip_code: this.userData.born_zip_code,

              // Employee Sizes
              shirt_size: this.userData.shirt_size,
              pants_size: this.userData.pants_size,
              shoe_size: this.userData.shoe_size,

              // Children
              children: this.validateInsertChildren(),
              // Studies
              studies: this.validateInsertStudies(),
              // Experiences
              experience: this.validateInsertExperience(),
              // Emergency Contact
              cname1: this.userData.contacts[0].name
                ? this.userData.contacts[0].name
                : " ",
              cphone1: this.userData.contacts[0].phone
                ? this.userData.contacts[0].phone
                : " ",
              coccupation1: this.userData.contacts[0].occupation
                ? this.userData.contacts[0].occupation
                : " ",
              crelation1: this.userData.contacts[0].relation_id
                ? this.userData.contacts[0].relation_id
                : " ",

              cname2: this.userData.contacts[1].name
                ? this.userData.contacts[1].name
                : " ",
              cphone2: this.userData.contacts[1].phone
                ? this.userData.contacts[1].phone
                : " ",
              coccupation2: this.userData.contacts[1].occupation
                ? this.userData.contacts[1].occupation
                : " ",
              crelation2: this.userData.contacts[1].relation_id
                ? this.userData.contacts[1].relation_id
                : " ",
              // user_id: this.currentUser.user_id,
              bank_accounts: this.validateInsertBankAccounts(),
            };

            const data = await EmployeesService.updateEmployeeInformation(
              params
            );
            if (data.status === 200) {
              this.refresh();
              await this.getInformationEmployeer();
              this.showToast(
                "success",
                "top-right",
                this.$t("Success Operation"),
                "CheckIcon",
                this.$t("Employee Updated Successfully")
              );
              await this.$store.dispatch(
                "RRHHEmployeesStore/A_EMPLOYEE_INFO",
                this.$route.params.id
              );
            }
          }
        }
      } catch (e) {
        this.showToastError(e);
      } finally {
        this.removePreloader();
      }
    },
    validateInsertChildren() {
      if (this.userData.children.length > 0) {
        const children = [];
        this.userData.children.map((son) => {
          if (
            son.names &&
            son.gender &&
            // son.document_number &&
            son.age &&
            son.dob
          ) {
            children.push({
              names: son.names,
              gender: son.gender,
              document_number: son.document_number ?? null,
              age: son.age,
              dob: moment(son.dob).format("YYYY-MM-DD"),
            });
          }
        });
        return children;
      } else {
        return [];
      }
    },
    validateInsertStudies() {
      if (this.userData.studies.length > 0) {
        const studies = [];
        this.userData.studies.map((study) => {
          if (
            study.study_grade &&
            study.study_center
            //  &&
            // study.carrera &&
            // study.start_date &&
            // study.finish_date
          ) {
            studies.push({
              study_grade: study.study_grade,
              study_center: study.study_center,
              carrera: study.carrera ?? null,
              start_date: moment(study.start_date).format("YYYY-MM-DD") == null || moment(study.start_date).format("YYYY-MM-DD") == "Invalid date" ? null : moment(study.start_date).format("YYYY-MM-DD"),
              finish_date: moment(study.finish_date).format("YYYY-MM-DD") == null || moment(study.finish_date).format("YYYY-MM-DD") == "Invalid date" ? null : moment(study.finish_date).format("YYYY-MM-DD"),
            });
          }
        });
        return studies;
      } else {
        return [];
      }
    },
    validateInsertExperience() {
      if (this.userData.experience.length > 0) {
        const experience = [];
        this.userData.experience.map((exp) => {
          if (
            exp.company_position &&
            exp.company 
            // &&
            // exp.start_date &&
            // exp.finish_date
          ) {
            experience.push({
              company_position: exp.company_position,
              company: exp.company,
              reference_contact: exp.reference_contact ?? null,
              number_contact: exp.number_contact ?? null,
              start_date: moment(exp.start_date).format("YYYY-MM-DD") == null || moment(exp.start_date).format("YYYY-MM-DD") == "Invalid date" ? null : moment(exp.start_date).format("YYYY-MM-DD"),
              finish_date: moment(exp.finish_date).format("YYYY-MM-DD") == null || moment(exp.finish_date).format("YYYY-MM-DD") == "Invalid date" ? null : moment(exp.finish_date).format("YYYY-MM-DD"),
            });
          }
        });
        return experience;
      } else {
        return [];
      }
    },

    validateInsertBankAccounts() {
      if (this.userData.bank_accounts.length > 0) {
        const bank_accounts = [];
        this.userData.bank_accounts.map((bank) => {
          if (
            bank.bank_id &&
            bank.account_number &&
            bank.bank_account_type_id 
            // &&
            // bank.cci
          ) {
            bank_accounts.push({
              bank_id: bank.bank_id,
              account_number: bank.account_number,
              bank_account_type_id: bank.bank_account_type_id,
              cci: bank.cci ?? null,
            });
          }
        });
        return bank_accounts;
      } else {
        return [];
      }
    },

    addChildren() {
      const son = {
        names: null,
        gender: null,
        document_number: null,
        age: null,
        dob: null,
      };
      this.userData.children.push(son);
    },
    deleteSon(index) {
      const children = [];
      this.userData.children.map((son, indexx) => {
        if (index != indexx) {
          children.push(son);
        }
      });
      this.userData.children = children;
    },
    addBankAccount() {
      if (this.userData.bank_accounts.length >= 5) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Warning",
            icon: "AlertTriangleIcon",
            variant: "warning",
            text: "Excede limite de items",
          },
        });
        return;
      }
      const bank_account = {
        id: null,
        bank_id: null,
        bank_account_type_id: null,
        account_number: null,
      };
      this.userData.bank_accounts.push(bank_account);
    },

    async deleteBankAccount(bank_account, index) {
      try {
        this.addPreloader();
        if (bank_account !== null && bank_account.id !== null) {
          this.setInactiveBankAccount(bank_account);
          await this.getInformationEmployeer();
          this.edit = true;
        } else [this.userData.bank_accounts.splice(index, 1)];
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async setInactiveBankAccount(bank_account) {
      try {
        const params = {
          id: bank_account.id,
          status: 2,
        };
        const { status } = await EmployeesService.changeStatusBankAccount(
          params
        );
        if (status === 200) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.$t("Success Operation"),
              icon: "CheckIcon",
              variant: "success",
              text: this.$t("Bank Account Deleted Successfully"),
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            icon: "XOctagonIcon",
            variant: "danger",
            text: this.$t("Error while deleting Bank Account"),
          },
        });
      }
    },

    addStudies() {
      if (this.userData.studies.length >= 5) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Warning",
            icon: "AlertTriangleIcon",
            variant: "warning",
            text: "Excede limite de items",
          },
        });
        return;
      }
      const study = {
        id: null,
        study_grade: null,
        study_center: null,
        carrera: null,
        start_date: null,
        finish_date: null,
      };
      this.userData.studies.push(study);
    },

    deleteStudy(index) {
      const studies = [];
      this.userData.studies.map((study, indexx) => {
        if (index != indexx) {
          studies.push(study);
        }
      });
      this.userData.studies = studies;
    },
    addExperience() {
      if (this.userData.experience.length >= 7) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Warning",
            icon: "AlertTriangleIcon",
            variant: "warning",
            text: "Excede limite de items",
          },
        });
        return;
      }
      const experience = {
        id: null,
        company_position: null,
        company: null,
        reference_contact: null,
        number_contact: null,
        start_date: null,
        finish_date: null,
      };
      this.userData.experience.push(experience);
    },
    deleteExperience(index) {
      const experience = [];
      this.userData.experience.map((exp, indexx) => {
        if (index != indexx) {
          experience.push(exp);
        }
      });
      this.userData.experience = experience;
    },
    refresh() {
      this.edit = true;
      this.userData = { ...this.userDataRefresh };
    },

    async getInformationEmployeer() {
      try {
        const params = {
          id: this.$route.params.id,
        };
        const { data } = await EmployeesService.getEmployeeInformation(params);
        this.userData = data[0];
        data.map((data) => {
          data.contacts = JSON.parse(data.contacts);
          data.children = JSON.parse(data.children);
          data.studies = JSON.parse(data.studies);
          data.experience = JSON.parse(data.experience);
          data.bank_accounts = JSON.parse(data.bank_accounts);

          if (data.contacts == null) {
            data.contacts = [
              {
                id: null,
                name: null,
                phone: null,
                relation: null,
                relation_id: null,
              },
              {
                id: null,
                name: null,
                phone: null,
                relation: null,
                relation_id: null,
              },
            ];
          }
          if (data.contacts.length == 1) {
            data.contacts = [
              {
                id: data.contacts[0].id,
                name: data.contacts[0].name,
                phone: data.contacts[0].phone,
                relation: data.contacts[0].relation,
                occupation: data.contacts[0].occupation,
                relation_id: data.contacts[0].relation_id,
              },
              {
                id: null,
                name: null,
                phone: null,
                relation: null,
                relation_id: null,
              },
            ];
          }
          if (data.children == null) {
            data.children = [
              {
                id: null,
                names: null,
                gender: null,
                document_number: null,
                age: null,
                dob: null,
              },
            ];
          }

          if (data.studies == null) {
            data.studies = [
              {
                id: null,
                study_grade: null,
                study_center: null,
                carrera: null,
                start_date: null,
                finish_date: null,
              },
            ];
          }

          if (data.experience == null) {
            data.experience = [
              {
                id: null,
                company_position: null,
                company: null,
                reference_contact: null,
                number_contact: null,
                start_date: null,
                finish_date: null,
              },
            ];
          }

          if (data.bank_accounts == null) {
            data.bank_accounts = [
              {
                id: null,
                bank_id: null,
                bank_account_type_id: null,
                account_number: null,
                cci: null,
              },
            ];
          }
        });
        this.userDataRefresh = { ...this.userData };
        return this.userData;
      } catch (e) {
        // this.showErrorSwal(e);
        console.log(e);
        return [];
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.space {
  width: auto;
}
.truncate {
  width: 75.5%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement="top"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}

#overpx .vs__dropdown-toggle .vs__selected-options .vs__search {
  margin: 9.15px 0 0 !important;
}

.title-uwu {
  font-weight: bold !important;
}

@media (max-width: 1366px) {
  .space {
    width: 44% !important;
  }

  .title_lable {
    width: 183px;
  }
}
.custom-caro.k-input {
  max-width: 218px !important;
  width: 300px !important;
}

.custom-caro2.k-input {
  max-width: 322px !important;
  width: 322px !important;
}

.invalid-v-select div {
  border-color: #fc424a !important;
}
// verificar si no afecta en algo - psdta si afecta en algo xd no deja salir del v-select
// .vs__search {
//   display: none !important;
// }



#fixed-buttons {
  position: relative;
}

#fixed-buttons.fixed {
  position: fixed;
  top: 10vh;
  right: 1.5vw;
  z-index: 1000;
}
</style>
